import script from "./ImageLightbox.vue?vue&type=script&setup=true&lang=js"
export * from "./ImageLightbox.vue?vue&type=script&setup=true&lang=js"

import "./ImageLightbox.vue?vue&type=style&index=0&id=557c9ae6&lang=css"

const __exports__ = script;

export default __exports__